export default __webpack_public_path__ + "static/media/Rubik-MediumItalic.35277cb9.woff";